export default {
  // Header
  nav: {
    inicio: 'Home',
    aurion: 'AURION',
    sectores: 'Sectors',
    metodo: 'Method',
    porQueAurion: 'Why AURION',
    noticias: 'News & Market',
    estudioGratuito: 'Free Assessment',
    faqs: 'FAQs',
    contacto: 'Contact'
  },

  // Hero
  hero: {
    titulo: '360º Industrial Energy Solutions',
    subtitulo: 'Integrated engineering, legal and financing to reduce costs and carbon footprint with renewable and sustainable technologies.',
    destacado1: 'We finance, design, legalize and operate your energy installations.',
    destacado2: 'You only pay a fixed price for the useful energy consumed, set from the start',
    beneficio1: 'Immediate savings on energy costs and long-term price stability',
    beneficio2: 'Industrial process decarbonization without CAPEX',
    beneficio3: 'Comprehensive project management: engineering, permits, construction, grants and subsidies',
    ctaEstudio: 'Request free assessment',
    ctaCasos: 'View cases and references'
  },

  // About Aurion
  about: {
    titulo: 'About AURION',
    subtitulo: 'Your strategic partner in industrial energy transition',
    descripcion: 'AURION is a company specialized in comprehensive energy solutions for the industrial and agri-food sector. We combine cutting-edge engineering, legal expertise and financial capacity to deliver turnkey projects.',
    experiencia: 'Years of experience',
    proyectos: 'Projects executed',
    mwInstalados: 'MW installed',
    satisfaccion: 'Customer satisfaction'
  },

  // Solutions
  solutions: {
    titulo: '360º Energy Solutions for Industry',
    subtitulo: 'A single point of contact for your entire industrial energy project cycle',
    ingenieria: {
      titulo: 'Industrial Engineering & Technology',
      descripcion: 'Photovoltaic for large industrial consumption, thermal biomass for steam and process heat, energy hybridization systems, smart batteries for peak management, digitalization and advanced installation control.',
      feature1: 'Technical design adapted to industrial processes',
      feature2: 'Integration with existing systems',
      feature3: 'Energy performance optimization',
      feature4: 'Real-time monitoring and control'
    },
    compliance: {
      titulo: 'Industrial Compliance & Legal',
      descripcion: 'Comprehensive industrial permit and license management, complete regulatory due diligence, corporate energy contracting and PPAs, alignment with environmental and ESG regulations.',
      feature1: 'Industrial permit processing',
      feature2: 'Complete regulatory audit',
      feature3: 'Energy contract negotiation',
      feature4: 'Guaranteed regulatory compliance'
    },
    financiacion: {
      titulo: 'Industrial Financing & Grants',
      descripcion: 'Corporate CAPEX/OPEX/PPA financial structures adapted to large projects, optimized financial structuring, Next Generation subsidy management and tax deductions, ESG reporting for investors.',
      feature1: 'Economic feasibility analysis',
      feature2: 'Tax and financial optimization',
      feature3: 'European grants management',
      feature4: 'Corporate ESG reports'
    },
    mensaje: 'We finance, design, legalize and operate your energy installations.',
    mensajeDestacado: 'You only pay a fixed price for the useful energy consumed, agreed from the start'
  },

  // Sectors
  sectors: {
    titulo: 'Activity Sectors',
    subtitulo: 'Solutions adapted to the specific needs of each industrial sector',
    manufacturera: {
      titulo: 'Manufacturing Industry',
      descripcion: 'Manufacturing processes, welding, heat treatments, compressed air, warehouse climate control'
    },
    agroalimentaria: {
      titulo: 'Agri-food',
      descripcion: 'Food processing, preservation, drying, refrigeration, CIP cleaning systems'
    },
    quimica: {
      titulo: 'Chemical',
      descripcion: 'Reaction processes, distillation, drying, temperature control, water treatment'
    },
    bebidas: {
      titulo: 'Beverage Industry',
      descripcion: 'Industrial refrigeration, pasteurization, CIP/SIP, bottling and packaging'
    },
    caucho: {
      titulo: 'Rubber Industry',
      descripcion: 'Vulcanization, mold heating, compressed air, curing systems'
    },
    textil: {
      titulo: 'Textile Industry',
      descripcion: 'Thermal processes for dyeing, drying and finishing, industrial steam, warehouse climate control'
    }
  },

  // Method
  method: {
    titulo: 'Our Method',
    subtitulo: 'A structured process to ensure the success of your energy project',
    paso1: {
      titulo: 'Analysis',
      descripcion: 'Detailed study of your consumption and energy needs'
    },
    paso2: {
      titulo: 'Design',
      descripcion: 'Optimal solution engineering adapted to your installation'
    },
    paso3: {
      titulo: 'Financing',
      descripcion: 'Financial structuring and grant management'
    },
    paso4: {
      titulo: 'Execution',
      descripcion: 'Turnkey installation with quality guarantee'
    },
    paso5: {
      titulo: 'Operation',
      descripcion: 'Maintenance and continuous system optimization'
    }
  },

  // Why Aurion
  whyAurion: {
    titulo: 'Why AURION?',
    subtitulo: 'The reasons that differentiate us in the industrial energy solutions market',
    razon1: {
      titulo: '360º Comprehensive Solution',
      descripcion: 'A single point of contact for engineering, legal and financing'
    },
    razon2: {
      titulo: 'No Initial Investment',
      descripcion: 'OPEX and PPA models that eliminate the CAPEX barrier'
    },
    razon3: {
      titulo: 'Guaranteed Fixed Price',
      descripcion: 'Long-term energy cost stability'
    },
    razon4: {
      titulo: 'Industrial Experience',
      descripcion: 'Specialists in large-scale and complex projects'
    },
    razon5: {
      titulo: 'ESG Commitment',
      descripcion: 'Alignment with corporate sustainability goals'
    },
    razon6: {
      titulo: 'Continuous Support',
      descripcion: 'Accompaniment throughout the project\'s useful life'
    }
  },

  // Key Metrics
  metrics: {
    titulo: 'Results That Speak for Themselves',
    subtitulo: 'Our numbers reflect the real impact of our solutions',
    ahorro: 'Average bill savings',
    co2: 'CO₂ tons avoided',
    proyectos: 'Completed projects',
    satisfaccion: 'Satisfaction index'
  },

  // Trust Bar
  trust: {
    titulo: 'They Trust Us',
    subtitulo: 'Leading companies that have transformed their energy model with AURION'
  },

  // News
  news: {
    titulo: 'News & Market',
    subtitulo: 'Stay up to date with the latest news in the energy sector',
    leerMas: 'Read more',
    verTodas: 'View all news'
  },

  // Gallery
  gallery: {
    titulo: 'Project Gallery',
    subtitulo: 'Discover some of our most outstanding projects in different sectors and energy solutions'
  },

  // Main Offer / Contact Form
  offer: {
    titulo: 'Free Savings & Carbon Footprint Assessment',
    subtitulo: 'We deliver a preliminary analysis with savings, investment and CO₂ reduction scenarios, with no commitment.',
    queIncluye: 'What your assessment includes',
    include1: 'Consumption baseline',
    include2: 'Proposed measures',
    include3: 'Savings estimation',
    include4: 'CO₂ reduction',
    include5: 'Investment range',
    include6: 'Applicable grants',
    include7: 'Recommended next step',
    entrega: 'Delivery in 5-7 business days',
    entregaDesc: 'You will receive a detailed report with specific recommendations for your installation',
    form: {
      provincia: 'Province',
      provinciaPlaceholder: 'Your province',
      poblacion: 'City',
      poblacionPlaceholder: 'Your city',
      empresa: 'Company',
      empresaPlaceholder: 'Your company name',
      nombre: 'Full name',
      nombrePlaceholder: 'Your full name',
      cargo: 'Position',
      cargoPlaceholder: 'Your position in the company',
      email: 'Email',
      emailPlaceholder: 'you@company.com',
      telefono: 'Phone',
      telefonoPlaceholder: '+34 600 000 000',
      enviar: 'Request free assessment',
      enviando: 'Sending...',
      exito: 'Request sent successfully!',
      exitoDesc: 'You will receive your assessment in 5-7 business days.',
      error: 'Error sending request',
      errorDesc: 'Please try again or contact us.',
      privacidad: 'By submitting this form you accept our privacy policy. We do not share your data with third parties.'
    }
  },

  // Footer
  footer: {
    descripcion: '360º energy solutions for industry and agri-food. Integrated engineering, legal and financing for energy transition.',
    soluciones: 'Solutions',
    sectores: 'Sectors',
    empresa: 'Company',
    recursos: 'Resources',
    ingenieria: 'Engineering & Technology',
    compliance: 'Compliance & Legal',
    financiacion: 'Financing & Grants',
    estudioGratuito: 'Free Assessment',
    manufacturera: 'Manufacturing Industry',
    agroalimentaria: 'Agri-food',
    casosExito: 'Success Cases',
    referencias: 'References',
    sobreAurion: 'About AURION',
    metodo: 'Our Method',
    equipo: 'Team',
    contacto: 'Contact',
    noticias: 'News & Market',
    faqs: 'FAQs',
    documentacion: 'Documentation',
    blog: 'Blog',
    derechos: 'All rights reserved.',
    privacidad: 'Privacy Policy',
    terminos: 'Terms of Use',
    cookies: 'Cookies',
    siguenos: 'Follow us:'
  },

  // Legal Pages
  legal: {
    privacidad: {
      titulo: 'Privacy Policy',
      contenido: 'This page will contain the privacy policy of AURION ENERGY S.L. Information about personal data processing, user rights and security measures.'
    },
    terminos: {
      titulo: 'Terms of Use',
      contenido: 'This page will contain the terms and conditions of use of the AURION ENERGY S.L. website. Rules of use, rights and obligations of users.'
    },
    cookies: {
      titulo: 'Cookie Policy',
      contenido: 'This page will contain the cookie policy of AURION ENERGY S.L. Information about the use of cookies, types of cookies used and how to manage them.'
    }
  }
};
